import { InbTransactionDetail } from './../model/shared/transaction/transaction';
import { BaseResponse } from './internal/baseresponse';

export class TransactionCheckRemittanceResult extends BaseResponse {
  data: InbTransactionDetail;
}



// WEBPACK FOOTER //
// ./src/app/response/transactioncheckremittanceresult.ts